import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SEOSchema from '@/components/feature/SEOSchema';

export default function AboutPage() {
  return (
    <>
      <SEOSchema type="WebPage" data={{
        name: '关于我们 - 韩国漫画网',
        description: '了解韩国漫画网的品牌故事、发展历程、用户口碑及联系方式。韩漫在线免费看，韩漫免费漫画在线观看下拉式免费阅读。',
        url: 'https://www.koreancomic.cn/about',
      }} />
      <Navbar />
      <main>
        <Breadcrumb items={[
          { label: '首页', href: '/' },
          { label: '关于我们' },
        ]} />

        {/* Brand Introduction */}
        <section className="py-10 md:py-16 bg-background-50">
          <div className="max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="max-w-3xl mx-auto text-center mb-12">
              <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">关于韩国漫画网</h1>
              <p className="text-foreground-500 leading-relaxed">
                您的韩漫在线免费看首选平台
              </p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center max-w-5xl mx-auto">
              <div>
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-4">品牌故事</h2>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                  韩国漫画网成立于2020年，是一群热爱韩国漫画的年轻人共同打造的中文韩漫在线阅读平台。我们深知中文读者对韩漫的热爱与需求，因此致力于打造一个免费、高质量、体验优良的韩国漫画在线阅读网站。
                </p>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                  经过多年的发展，韩国漫画网已经积累了超过10000部韩漫资源，涵盖恋爱、喜剧、奇幻、动作、悬疑、日常、剧情、恐怖八大分类，累计服务超过500万名中文读者。我们始终坚持以用户为中心，不断优化阅读体验。
                </p>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  我们的使命是让每一位中文读者都能轻松享受韩漫的魅力。无论你是韩漫新手还是资深粉丝，都能在韩国漫画网找到属于自己的那份快乐。韩漫在线免费看，我们用心做好每一个细节。
                </p>
              </div>
              <div className="rounded-lg overflow-hidden border border-background-200/70">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20modern%20cozy%20reading%20space%20with%20warm%20lighting%2C%20bookshelves%20filled%20with%20colorful%20comics%2C%20a%20comfortable%20reading%20nook%20with%20cushions%2C%20soft%20natural%20light%20from%20large%20window%2C%20minimalist%20Korean%20interior%20design%2C%20artistic%20composition%2C%20inviting%20and%20peaceful%20atmosphere%2C%20clean%20aesthetic%2C%20warm%20neutral%20tones&width=800&height=600&seq=about-brand-story&orientation=landscape"
                  alt="韩国漫画网 - 品牌故事"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Stats & Reputation */}
        <section className="py-10 md:py-14 bg-background-100">
          <div className="max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">我们的成绩</h2>
              <p className="text-sm text-foreground-500 mt-2">用数据说话，来自读者的真实认可</p>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-4xl mx-auto mb-12">
              {[
                { value: '10000+', label: '韩漫资源', icon: 'ri-book-read-line' },
                { value: '500万+', label: '忠实读者', icon: 'ri-user-heart-line' },
                { value: '8大', label: '分类频道', icon: 'ri-grid-line' },
                { value: '99.6%', label: '好评率', icon: 'ri-thumb-up-line' },
              ].map((stat) => (
                <div key={stat.label} className="bg-background-50 rounded-lg border border-background-200/70 p-5 text-center">
                  <div className="w-10 h-10 mx-auto flex items-center justify-center rounded-full bg-primary-50 text-primary-500 mb-3">
                    <i className={stat.icon}></i>
                  </div>
                  <p className="text-2xl font-bold text-foreground-900">{stat.value}</p>
                  <p className="text-xs text-foreground-500 mt-1">{stat.label}</p>
                </div>
              ))}
            </div>

            <div className="max-w-3xl mx-auto">
              <h3 className="text-lg font-heading font-bold text-foreground-900 mb-6 text-center">读者口碑</h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                {[
                  { name: '小猫咪爱吃鱼', text: '韩国漫画网的阅读体验真的很好！下拉式阅读很流畅，画质也很清晰。追了好多部韩漫，全免费真的太良心了！', rating: 5 },
                  { name: '漫画控阿杰', text: '分类很齐全，找漫画很方便。更新速度也很快，每天都上来看看有没有新的章节。推荐给所有喜欢韩漫的朋友！', rating: 5 },
                  { name: '樱花飘落的季节', text: '从朋友那里知道的韩国漫画网，从此一发不可收拾。收藏了好多恋爱漫画，每天睡前看一话是最幸福的事。', rating: 5 },
                ].map((review) => (
                  <div key={review.name} className="bg-background-50 rounded-lg border border-background-200/70 p-4">
                    <div className="flex items-center gap-1 mb-2">
                      {Array.from({ length: review.rating }, (_, i) => (
                        <div key={i} className="w-4 h-4 flex items-center justify-center text-accent-500">
                          <i className="ri-star-fill"></i>
                        </div>
                      ))}
                    </div>
                    <p className="text-xs text-foreground-600 leading-relaxed mb-3">{review.text}</p>
                    <p className="text-xs font-medium text-foreground-800">—— {review.name}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section id="contact" className="py-10 md:py-16 bg-background-50">
          <div className="max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="max-w-3xl mx-auto text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">联系我们</h2>
              <p className="text-sm text-foreground-500 mt-2">有任何问题或建议？欢迎随时联系我们</p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-5xl mx-auto">
              <div>
                <div className="space-y-4">
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-50 text-primary-500 flex-shrink-0">
                      <i className="ri-mail-line"></i>
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-900">电子邮箱</h3>
                      <p className="text-sm text-foreground-500">contact@koreancomic.cn</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-50 text-accent-500 flex-shrink-0">
                      <i className="ri-wechat-line"></i>
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-900">微信公众号</h3>
                      <p className="text-sm text-foreground-500">韩国漫画网官方</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-50 text-secondary-500 flex-shrink-0">
                      <i className="ri-weibo-line"></i>
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-900">微博</h3>
                      <p className="text-sm text-foreground-500">@韩国漫画网官方微博</p>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <form
                  className="space-y-3 bg-background-100 rounded-lg p-5 border border-background-200/70"
                  data-readdy-form="contact-form"
                  onSubmit={async (e) => {
                    e.preventDefault();
                    const form = e.currentTarget as HTMLFormElement;
                    const formData = new FormData(form);
                    const websiteAlt = formData.get('website_alt') as string;
                    if (websiteAlt && websiteAlt.trim()) {
                      return;
                    }
                    formData.delete('website_alt');
                    const urlSearchParams = new URLSearchParams();
                    formData.forEach((value, key) => {
                      urlSearchParams.append(key, value as string);
                    });
                    try {
                      const response = await fetch('https://readdy.ai/api/form/d9pemadi2vhsdh2d32pg', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                        body: urlSearchParams.toString(),
                      });
                      const responseText = await response.text();
                      let parsed;
                      try { parsed = JSON.parse(responseText); } catch { parsed = null; }
                      const alertMsg = document.getElementById('contact-form-msg');
                      if (response.ok && parsed?.code === 'OK') {
                        if (alertMsg) { alertMsg.textContent = '留言已发送，感谢您的来信！'; alertMsg.className = 'text-xs text-green-600 mt-2'; }
                        form.reset();
                      } else {
                        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || '发送失败，请稍后重试';
                        if (alertMsg) { alertMsg.textContent = serverMsg; alertMsg.className = 'text-xs text-red-500 mt-2'; }
                      }
                    } catch {
                      const alertMsg = document.getElementById('contact-form-msg');
                      if (alertMsg) { alertMsg.textContent = '网络错误，请稍后重试'; alertMsg.className = 'text-xs text-red-500 mt-2'; }
                    }
                  }}
                >
                  <div>
                    <label htmlFor="contact-name" className="block text-xs font-medium text-foreground-700 mb-1">姓名</label>
                    <input
                      type="text"
                      id="contact-name"
                      name="name"
                      required
                      className="w-full px-3 py-2 rounded-lg border border-background-200/70 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors"
                      placeholder="请输入您的姓名"
                    />
                  </div>
                  <div>
                    <label htmlFor="contact-email" className="block text-xs font-medium text-foreground-700 mb-1">邮箱</label>
                    <input
                      type="email"
                      id="contact-email"
                      name="email"
                      required
                      className="w-full px-3 py-2 rounded-lg border border-background-200/70 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors"
                      placeholder="请输入您的邮箱"
                    />
                  </div>
                  <div>
                    <label htmlFor="contact-message" className="block text-xs font-medium text-foreground-700 mb-1">留言</label>
                    <textarea
                      id="contact-message"
                      name="message"
                      required
                      maxLength={500}
                      rows={4}
                      className="w-full px-3 py-2 rounded-lg border border-background-200/70 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors resize-none"
                      placeholder="请输入您的留言（500字以内）"
                    ></textarea>
                  </div>
                  <div className="website-alt-field">
                    <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
                  </div>
                  <button
                    type="submit"
                    className="w-full px-4 py-3 rounded-lg bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
                  >
                    发送留言
                  </button>
                  <p id="contact-form-msg" className="text-xs text-center mt-2"></p>
                </form>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}